import React, { FC } from "react";
import classNames from "classnames";
import EmptyStateBlocks from "./EmptyStateBlocks";

interface IEmptyStateProps {
  title: string;
  subtitle?: string;
  isDashed?: boolean;
  className?: string;
  image?: React.ReactElement;
}

const BASE_CLASS_NAME = "empty-state";

// eslint-disable-next-line react/prop-types
const EmptyState: FC<IEmptyStateProps> = ({ title, subtitle, isDashed, image, children, ...rest }) => {
  return (
    <div className={classNames(BASE_CLASS_NAME, { [`${BASE_CLASS_NAME}--dashed`]: isDashed })} {...rest}>
      <div className={`${BASE_CLASS_NAME}__content`}>
        {image ? image : <EmptyStateBlocks className={`${BASE_CLASS_NAME}__image`} />}
        <div className={`${BASE_CLASS_NAME}__title`}>{title}</div>
        {subtitle && <div className={`${BASE_CLASS_NAME}__subtitle`}>{subtitle}</div>}
      </div>
      {children}
    </div>
  );
};

export default EmptyState;
